import { optimizedTimeSheet, timeSheet } from "@planzone/dto";
import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveTimeSheetRequestFailure(project, resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, resource, filter, size),
      );

      return req ? req.request.isFailure : false;
    },
    isRetrieveTimeSheetRequestPending(project, resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, resource, filter, size),
      );

      return req ? req.request.isPending : false;
    },
    isRetrieveTimeSheetRequestSuccess(project, resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, resource, filter, size),
      );

      return req ? req.request.isSuccessful : false;
    },
    isTimeSheetDirty(project, resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, resource, filter, size),
      );

      return req ? req.isDirty : false;
    },
    getTimeSheet(project, resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, resource, filter, size),
      );

      return req ? req.timeSheet : optimizedTimeSheet;
    },
    getTimeSheetCurrentPage(project, resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, resource, filter, size),
      );

      return req ? req.page : 0;
    },
    canLoadMoreTimeSheet(project, resource, filter, size) {
      const req = getState().find((req) =>
        matchRequest(req, project, resource, filter, size),
      );

      return req ? req.canLoadMore : true;
    },
  };
}

export { createSelector };
